/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey, all = false, inboxId = null, signal } = {}) {
    const params = new URLSearchParams();
    if (searchKey) params.append('search', searchKey);
    if (all) params.append('all', true);
    if (inboxId) params.append('inbox_id', inboxId);
    const query = params.toString();
    const url = query ? `${this.url}?${query}` : this.url;
    return axios.get(url, { signal });
  }

  getGrouped({ searchKey, signal } = {}) {
    const params = new URLSearchParams();
    if (searchKey) params.append('search', searchKey);
    const query = params.toString();
    const url = query ? `${this.url}/grouped?${query}` : `${this.url}/grouped`;
    return axios.get(url, { signal });
  }

  importTable(file, { visibility, user_ids = [], team_ids = [] } = {}) {
    const formData = new FormData();
    formData.append('file', file);
    if (visibility) formData.append('visibility', visibility);
    user_ids.forEach(id => formData.append('user_ids[]', id));
    team_ids.forEach(id => formData.append('team_ids[]', id));
    return axios.post(`${this.url}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new CannedResponse();
